export const productIDs = [
    'ASNAanvullendPensioenOpbouwen',
    'ASNBankrekening',
    'ASNBankrekeningIdeaalsparen',
    'ASNGespreidbeleggen',
    'ASNDepositosparen',
    'ASNIdeaalsparen',
    'ASNJeugdsparen',
    'ASNJongerenpakket',
    'ASNStudentenrekening',
    'ASNThemabeleggen',
    'RegioBankDoelbeleggen',
    'RegioBankPlusBetalen',
    'RegioBankPlusBetalenSpaarOpMaatVrij',
    'RegioBankSpaarOpMaatVrij',
    'RegioBankStudentenrekening',
    'Keuzedeposito',
    'JongWijs',
    'RegioBankThemabeleggen',
    'SNSBasis',
    'SNSBasisInternetSparen',
    'SNSBeleggingsrekening',
    'SNSCompleet',
    'SNSCompleetInternetSparen',
    'SNSDeposito',
    'SNSDoelbeleggen',
    'SNSInternetSparen',
    'SNSJeugdsparen',
    'SNSJongerenpakket',
    'SNSLijfrente',
    'SNSStudentenrekening'
];

export enum CasePrefix {
    ACTIVATION_JOURNEY = 'ACJ',
    ORIENTATION = 'OT',
    LEGACY_ONC = 'O',
    LEGACY_MBR = 'M',
    V2_ORCHESTRATION = 'ORC',
    V2_ONC = 'ONC',
    V2_MBR = 'MBR'
}

export enum DistributionChannelType {
    RETAIL = 'Retail',
    MIJN = 'MijnOmgeving',
    MOBIEL = 'MobileApp'
}
